import React from "react";
import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";
import Logo from "@/components/Logo";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white flex items-center justify-center p-6">
      <div className="w-full max-w-md text-center border border-white/10 p-10" data-testid="payment-cancel-page">
        <Logo className="h-12 w-12 mx-auto mb-6" />
        <XCircle className="h-12 w-12 text-[#FF9500] mx-auto mb-4" />
        <h1 className="font-display text-2xl uppercase tracking-tight">Checkout cancelled</h1>
        <p className="text-zinc-200 text-sm mt-2">No charge was made. You can pick a plan whenever you're ready.</p>
        <Button data-testid="cancel-back-btn" onClick={() => navigate("/subscribe")} className="mt-8 h-12 w-full rounded-none bg-[#E2E30A] hover:bg-[#c9ca09] text-black font-semibold uppercase tracking-wide transition-colors">
          Back to plans
        </Button>
      </div>
    </div>
  );
}
